var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('module',[(_vm.auth('b_freight_company'))?_c('company-list'):_vm._e(),(_vm.auth('b_deliveryaddress'))?_c('deliveryaddress-list'):_vm._e(),(_vm.auth('b_after_sale_address'))?_c('address-list'):_vm._e(),(_vm.auth('b_freight_template'))?_c('template-list'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }